import { render } from "./home.vue?vue&type=template&id=5f3ec99a"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=5f3ec99a&lang=css"

import exportComponent from "/Users/swdz/devPhp/hbx_code/chatWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__